import React from 'react';
import { Container } from '../ui/Container';
import { SectionHeading } from '../ui/SectionHeading';
import { FAQItem } from '../ui/FAQItem';
export const FAQSection: React.FC = () => {
  const faqs = [{
    question: 'How is getdealflow.ai different from a broker or finder?',
    answer: 'Brokers take 4–6% and shop deals to the highest bidder. Finders often recycle old contacts. We help you source exclusively, proactively, and cost-efficiently—with your own branded sourcing engine.'
  }, {
    question: 'How does this compare to hiring an internal Business Development team?',
    answer: 'An in-house team can easily cost $400K+ per year and months to build. We give you a fully-managed team—media buyer, SDR, funnel builder, CRM, and strategist—for a fraction of the cost, with results in weeks, not quarters.'
  }, {
    question: 'What types of firms are the best fit for getdealflow.ai?',
    answer: "We work best with PE firms, independent sponsors, family offices, and holdcos acquiring businesses in the $500k–$25M EBITDA range. If you have a clear buy box and capital to deploy, we'll help you fill the top of your funnel with qualified sellers."
  }, {
    question: 'How fast can we launch?',
    answer: 'We typically go live within 21–30 days of kickoff. That includes ad buildout, funnel development, SDR onboarding, and your CRM connection. Your first qualified leads typically arrive in the first 30 days.'
  }, {
    question: 'Do we need to manage anything internally?',
    answer: 'Nope. We handle the ad strategy, media buying, funnel optimization, SDR team, lead screening, and reporting. You only step in once deals are pre-vetted and ready for your team.'
  }, {
    question: 'Do you work with existing sourcing or deal teams?',
    answer: 'Absolutely. We can operate independently or integrate with your internal BD/CRM team to enhance visibility and reporting.'
  }];
  return <section className="w-full bg-gradient-to-b from-dark-900 to-dark-800 py-24 relative" data-id="element-580">
      <div className="absolute inset-0 bg-[url('https://transparenttextures.com/patterns/carbon-fibre.png')] opacity-5" data-id="element-581" />
      <Container className="relative" data-id="element-582">
        <SectionHeading title="Common Questions" centered className="text-white" data-id="element-583" />
        <div className="max-w-3xl mx-auto" data-id="element-584">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-585" />)}
        </div>
      </Container>
    </section>;
};